import script from "./HostingCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./HostingCreate.vue?vue&type=script&setup=true&lang=js"

import "./HostingCreate.vue?vue&type=style&index=0&id=61317ecf&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61317ecf"]])

export default __exports__